const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 40' fill='currentColor' {...props}>
    <path
      d='M8.75 0C9.44036 0 10 0.559644 10 1.25V2.5H30V1.25C30 0.559644 30.5596 0 31.25 0C31.9404 0 32.5 0.559644 32.5 1.25V2.5H35C37.7614 2.5 40 4.73858 40 7.5V35C40 37.7614 37.7614 40 35 40H5C2.23858 40 0 37.7614 0 35V7.5C0 4.73858 2.23858 2.5 5 2.5H7.5V1.25C7.5 0.559644 8.05964 0 8.75 0ZM2.5 10V35C2.5 36.3807 3.61929 37.5 5 37.5H35C36.3807 37.5 37.5 36.3807 37.5 35V10H2.5Z'
      fill='currentColor'
    />
  </svg>
);

export default Calendar;
